import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { ChatCommonService } from "../../../../services/chat-common.service";
import { VariableService } from "../../../../services/variable.service";
import { DropDownService } from "src/app/shared/services/dropdown.service";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";

  constructor(public router: Router,
    private authService: AuthService,
    public ccs: ChatCommonService,
    public vars: VariableService,
    public dropDownService: DropDownService,
  ) {
    // if (JSON.parse(localStorage.getItem("user"))) {
    // } else {
    // }
  }

  ngOnInit() { }


  toggleFileInputButton(event: Event, btn: HTMLButtonElement, chatCustomDropDown12: HTMLElement, type: number) {
    btn?.classList.toggle('toggled')
    // this.chatCommonService.adjustTextareaHeight();
    this.dropDownService.toggleDropdown(event, chatCustomDropDown12, '', type, 'none')
  }

  logoutFunc() {
    this.authService.logout();
    // this.router.navigateByUrl('auth/login');
    location.href = 'auth/login'
  }
}
